/*
  Ported from src/pages/ExpertisePage.tsx — scoreProducts() ported verbatim
  (fixed closed lookup over 6 product ids, not a dynamic query). Candidate
  product data is pre-rendered as hidden blocks in the Liquid section and
  shown/hidden here — no network round-trip, matching the original's instant
  local state.
*/
(function () {
  function scoreProducts(group, budget, priority) {
    var scores = {
      'v-lux-v10': 0,
      hypernet: 0,
      'velocity-core': 0,
      omnicore: 0,
      'apex-kinetic': 0,
      rifters: 0,
    };

    if (group === 'solo') {
      scores['apex-kinetic'] += 3;
      scores.rifters += 2;
      scores['v-lux-v10'] -= 3;
      scores.hypernet -= 3;
      scores['velocity-core'] -= 3;
      scores.omnicore -= 3;
    } else if (group === 'duo') {
      scores['apex-kinetic'] += 2;
      scores.rifters += 2;
      scores['v-lux-v10'] -= 1;
    } else {
      scores['v-lux-v10'] += 3;
      scores.hypernet += 3;
      scores['velocity-core'] += 3;
      scores.omnicore += 4;
      scores['apex-kinetic'] -= 3;
      scores.rifters -= 3;
    }

    if (budget === 'under100') {
      scores['apex-kinetic'] += 3;
    } else if (budget === 'mid') {
      scores.hypernet += 2;
      scores.rifters += 2;
      scores['velocity-core'] += 1;
    } else {
      scores['v-lux-v10'] += 3;
      scores['velocity-core'] += 2;
      scores.omnicore += 2;
    }

    if (priority === 'price') {
      scores['apex-kinetic'] += 2;
      scores.hypernet += 1;
    } else if (priority === 'weight') {
      scores['velocity-core'] += 3;
    } else if (priority === 'reliability') {
      scores['v-lux-v10'] += 3;
    } else {
      scores.hypernet += 2;
      scores.rifters += 3;
    }

    var bestId = Object.entries(scores).sort(function (a, b) {
      return b[1] - a[1];
    })[0][0];
    return bestId;
  }

  function initQuiz(root) {
    var state = { group: null, budget: null, priority: null };
    var resultWrap = root.querySelector('[data-quiz-result]');
    var candidates = root.querySelectorAll('[data-quiz-candidate]');

    function update() {
      if (!state.group || !state.budget || !state.priority) {
        resultWrap.hidden = true;
        return;
      }
      var bestId = scoreProducts(state.group, state.budget, state.priority);
      candidates.forEach(function (el) {
        el.hidden = el.getAttribute('data-quiz-candidate') !== bestId;
      });
      resultWrap.hidden = false;
    }

    root.querySelectorAll('[data-quiz-option]').forEach(function (button) {
      button.addEventListener('click', function () {
        var question = button.getAttribute('data-quiz-question');
        var value = button.getAttribute('data-quiz-option');
        state[question] = value;

        root.querySelectorAll('[data-quiz-question="' + question + '"]').forEach(function (b) {
          b.classList.toggle('is-active', b === button);
        });
        update();
      });
    });
  }

  function initForm(root) {
    var form = root.querySelector('[data-expertise-form]');
    if (!form) return;
    var submitLabel = form.querySelector('oblivion-descramble');
    var defaultText = submitLabel ? submitLabel.textContent : '';

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var name = form.querySelector('[name="name"]').value;
      var email = form.querySelector('[name="email"]').value;
      var phone = form.querySelector('[name="phone"]').value;
      var profile = form.querySelector('[name="profile"]').value;

      var recommended = root.querySelector('[data-quiz-candidate]:not([hidden])');
      var recoLine = recommended && !root.querySelector('[data-quiz-result]').hidden
        ? 'Recommandation quiz : ' + recommended.getAttribute('data-quiz-name') + '\n\n'
        : '';

      var subject = encodeURIComponent('Demande de conseil Oblivion — ' + (name || 'Nouveau pilote'));
      var body = encodeURIComponent(
        recoLine + 'Profil de conduite :\n' + profile + '\n\n— ' + name + ' (' + email + (phone ? ', ' + phone : '') + ')'
      );
      window.location.href = 'mailto:Oblivionintercom@support.fr?subject=' + subject + '&body=' + body;
      if (submitLabel) submitLabel.textContent = 'CLIENT MAIL OUVERT';
    });
  }

  function boot() {
    document.querySelectorAll('[data-oblivion-expertise]').forEach(function (root) {
      initQuiz(root);
      initForm(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
